import { render, staticRenderFns } from "./Transfers.vue?vue&type=template&id=6d195e14&scoped=true"
import script from "./Transfers.vue?vue&type=script&lang=js"
export * from "./Transfers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d195e14",
  null
  
)

export default component.exports